import React, { useState, useEffect } from 'react';
import '../graphStyles.scss'
import { ExportCSVButton } from '../../ExportCSVButton'
import NoDataFound from "../../NoDataFound"
import { visitorsBoughtTitle } from "../../../helper/Controllers/StatusController";
import DateRangeFilter from "../DateRangeFilter/DateRangeFilter";
import useDateRangeFilter from "../DateRangeFilter/useDateRangeFilter";

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    Filler,
    BarController
);

export function UniqueVisitorsWhoBoughtGraph({ weeks, visitors, percentOfVisitors }) {
    const [title, setTitle] = useState("");
    const { filteredWeeks, filteredData, onFilterChange } = useDateRangeFilter({
        weeks,
        dataArrays: { visitors, percentOfVisitors },
    });

    useEffect(() => {
        const fetch = async () => {
            const response = await visitorsBoughtTitle();
            setTitle(response);
        };
        fetch();
    }, []);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                },
                onHover: function(event, legendItem) {
                    document.getElementById("chart4").style.cursor = 'pointer';
                },
                onLeave: function(event, legendItem) {
                    document.getElementById("chart4").style.cursor = 'default';
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Week',
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                },
                grid: {
                    display: false,
                },
                ticks: {
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                }
            },
            y: {
                type: 'linear',
                position: 'left',
                title: {
                    display: true,
                    text: "Number of buyers",
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                },
                ticks: {
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                }              
            },
            y1: {
                type: 'linear',
                position: 'right',
                min: 0,
                title: {
                    display: true,
                    text: '% of add to cart',
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                },
                ticks: {
                    font: {
                        size: function() {
                            return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
                        }, 
                    },
                }
            }
        },
    };

    const labels = filteredWeeks;
    const data = {
        labels,
        datasets: [
            {
                label: '% of total visitors',
                data: filteredData.percentOfVisitors,
                type: 'line',
                fill: true,
                borderWidth: 3,
                borderColor: 'rgba(250, 210, 90, 0.99)',
                backgroundColor: 'rgba(250, 210, 90, 0.45)',
                hoverBackgroundColor: 'rgba(250, 210, 90, 0.45)',
                yAxisID: 'y1',
                pointRadius: function() {
                    return window.innerWidth < 990 && window.innerWidth > 700 ? 2.5 : 1.5;
                }
            },
            {
                label: 'Number of visitors',
                data: filteredData.visitors,
                backgroundColor: 'rgba(250, 118, 85, 0.99)',
                hoverBackgroundColor: 'rgba(250, 118, 85, 0.99)',
                yAxisID: 'y',
            },
        ],
    };

    const allData = [['Number of visitors buying', ...filteredData.visitors], ['% of add to cart', ...filteredData.percentOfVisitors]];

    return (
        <div className="graph">
            <div className="graph__title flex flex-col md:flex-row justify-between items-center">
                <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0">
                    {title ?? 'Unique visitors who bought'}
                </h4>
                <div className="flex items-center gap-2 flex-wrap justify-end pr-3">
                    <DateRangeFilter weeks={weeks} onFilterChange={onFilterChange} />
                    <ExportCSVButton
                        allData={allData}
                        name={"Unique_visitors_who_bought"}
                        className="w-full md:w-auto"
                    />
                </div>
            </div>
            {weeks?.length === 0 ? (
                <NoDataFound />
            ) : (
                <div className="relative w-full h-64 md:h-96">
                    <Chart className="chart" id="chart4" type="bar" options={options} data={data} />
                </div>
            )}
        </div>
    );
}